export default __webpack_public_path__ + "static/media/common-inner-nfo-banner-mob.835f9f9c.png";